import React from 'react';
import FormSelect from '@homeaway/react-form-select';

const AgeSelect = ({items, index, value, onAgeChange}) => {
    function handleChange(event) {
        onAgeChange(index, event.target.value);
    }

    return (
        <FormSelect
            floatingLabel={false}
            id={`age-select-${index}`}
            items={items}
            label={`select age of child ${index + 1}`}
            onChange={handleChange}
            name={`age-select-${index}`}
            value={value}
        />
    );
};

export default AgeSelect;